module.exports = __webpack_public_path__ + "img/company27.ae224b69.png";